export enum AppRole {
	Admin = 'admin',
	Regular = 'regular',
	Therapist = 'therapist',
}
